import CreateKnockoutRoom from "../../components/games/Knockout/CreateRoom";
import authenticated from "../middleware/authenticated";
import connectToWebsocket from "../middleware/connectToWebsocket";
import NewGameKnockout from "../../components/NewGameKnockout";
import KnockoutGame from "../../components/games/Knockout/KnockoutGame";

export default [
    {
        path: '/game/knockout',
        component: CreateKnockoutRoom,
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/game/multiplayer/knockout',
        component: NewGameKnockout,
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },

    {
        path: '/k/:code',
        component: KnockoutGame,
        name: 'findKnockoutGame',
        props: route => {
            return {
                code: route.params.code
            }
        },
        meta: {
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },
];